// User Management
export const tableColumns = {
  UserFullName: 'Employee Name',
  Email: 'Email',
  Name: 'Login ID',
  RoleName: 'Role Name',
  Status: 'Status',
};

// Application Services
export const applicationServicesHeaders = ['Process Name'];
